import { t } from "i18next";
import { StyledDiv } from "views/Admin/subviews/FooterLinks/FooterLinks.styles";
import { useTranslation } from "react-i18next";

export default function Terms2() {
  const { t } = useTranslation();
  // Text has been coded for automatic translation using i18nexus. Nameing conventions for this will be as follows:
  // u-(text)-(text) is for words that all start with a capital letter ie. u-happy-feelings = Happy Feelings
  // s-(text)-(text)-(number) is for a sentence or paragraph that needs indexing. On this page the naming convention is different because there are multiple paragraphs one after another that need an index.
  // The naming convention can be read as follows: s(sentence/paragraph)-h(heading) or l(list item) or p(paragraph)-pp(privacy policy)-1(index)

  return (
    <StyledDiv>
      <h1>Life365 Terms & Conditions of Use</h1>
      <h2>Last Updated: JANUARY 1, 2023</h2>
      <p>
        ​Welcome to a Life365 website! ​Life365, Inc. and its subsidiaries (or
        affiliations), Life365 Health, LLC, Life365.MyShopify.com, LifeConnect,
        LLC, Life365 Labs, LLC and HealtheLife, LLC Website (“Life365,”
        "Life365.Health," "Life365.MyShopify," "LifeConnect," "Life365 Labs,"
        "HealtheLife," “we,” “our,” or “us”) provides this website (“Website”)
        to you for your convenience and in order to provide you the ability to
        access certain health related information and services.
      </p>
      <p>
        Your access to this Website is subject to your agreement with these
        Terms & Conditions of Use (including our Privacy Policy). These Terms &
        Conditions together with our Privacy Policy constitute the agreement
        between you and LIFE365 regarding use of this Website (“Agreement”).
        Should you choose to register to access the non-public patient portal
        (“Portal”) via this Website, your use of this Website and Portal is also
        subject to the Life365 Portal Registration Agreement(“Portal
        Registration Agreement“) that you agree to during the registration
        process, which is also part of your Agreement with LIFE365.
      </p>
      <h3>
        PLEASE READ THIS AGREEMENT CAREFULLY BEFORE ACCESSING OR USING THE
        WEBSITE OR PORTAL. BY ACCESSING OR USING THE WEBSITE OR PORTAL, YOU
        AGREE TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS BELOW. PLEASE PRINT
        A COPY OF THESE TERMS & CONDITIONS OF USE FOR YOUR REFERENCE.
      </h3>
      <h2>​Modifications to this Agreement</h2>
      <h3>
        LIFE365 MAY REVISE THESE TERMS & CONDITIONS OF USE AT ANY TIME. SHOULD
        ANY REVISIONS BE MADE, LIFE365 WILL GIVE NOTICE TO YOU AND ALL USERS BY
        POSTING A NOTICE REGARDING THE REVISIONS ON THIS WEBSITE, AND THE NEW
        REVISIONS WILL BE EFFECTIVE AS OF THEIR POSTING. BY ACCESSING OR USING
        THIS WEBSITE AFTER SUCH REVISIONS ARE POSTED YOU AGREE AND CONSENT TO
        ALL SUCH REVISIONS.
      </h3>
      <h2>No Medical Advice</h2>
      <h3>
        LIFE365 IS NOT RESPONSIBLE FOR ANY CONTENT THAT A THIRD PARTY MAY MAKE
        AVAILABLE OR COMMUNICATE THROUGH THIS WEBSITE OR THE PORTAL.
      </h3>
      <h3>
        ANY LIFE365 OR THIRD PARTY CONTENT MADE AVAILABLE TO YOU ON THIS WEBSITE
        IS TO BE USED FOR INFORMATIONAL PURPOSES ONLY. YOU ACKNOWLEDGE THAT
        LIFE365 CONTENT IS IN NO CASE TO BE USED AS A SUBSTITUTE FOR
        PROFESSIONAL MEDICAL ADVICE NOR IS IT INTENDED TO BE RELIED UPON BY ANY
        PERSON OR ENTITY FOR PURPOSES OF MEDICAL DIAGNOSIS OR TREATMENT. LIFE365
        OR ITS VENDORS SHALL USE COMMERCIALLY REASONABLE EFFORTS TO ENSURE THE
        ACCURACY OF THE CONTENT, BUT NEITHER LIFE365 NOR ITS AFFILIATES OR
        VENDORS GUARANTEES THE SEQUENCE, ACCURACY, OR COMPLETENESS OF THE
        CONTENT AND SHALL NOT BE LIABLE IN ANY WAY TO YOU, OR ANYONE ELSE TO
        WHOM THE CONTENT MAY BE FURNISHED, FOR ANY DELAYS, INACCURACIES,
        UNAVAILABILITY, ERRORS OR OMISSIONS IN THE CONTENT. SUCH CONTENT IS
        RELIED UPON AT YOUR OWN RISK AND SOLE DISCRETION.
      </h3>
      <h3>
        IF YOU ARE A PATIENT OR LEGAL REPRESENTATIVE OF A PATIENT, CERTAIN
        CONTENT MAY CONSIST OF YOUR IDENTIFIABLE HEALTH INFORMATION MAINTAINED
        IN YOUR ELECTRONIC HEALTH RECORDS MAINTAINED BY YOUR HEALTHCARE
        PROVIDER. LIFE365 IS NOT YOUR PROVIDER AND THEREFORE YOU ACKNOWLEDGE
        THAT LIFE365 HAS NO RESPONSIBILITY OR LIABILITY FOR THE IDENTIFIABLE
        HEALTH INFORMATION MAINTAINED BY YOUR PROVIDER. IF YOU HAVE ANY
        QUESTIONS OR CONCERNS ABOUT THE IDENTIFIABLE HEALTH INFORMATION IN YOUR
        ELECTRONIC HEALTH RECORD, PLEASE CONTACT YOUR HEALTHCARE PROVIDER TO
        DISCUSS.
      </h3>
      <h2>Website Content and Access</h2>
      <p>
        LIFE365 reserves the right without prior notice to discontinue any
        services or content available on this Website, or otherwise change
        specifications at any time without incurring any obligations to you or
        any other party.
      </p>
      <h2>Privacy Policy</h2>
      <p>
        Access to this Website may be monitored from time to time by LIFE365.
        Your use of this Website constitutes your consent to such monitoring and
        data collection as set forth in our Privacy Policy.
      </p>
      <h2>Ownership</h2>
      <p>
        ​The content on this Website, including without limitation the text,
        graphics, logos, button icons, images, video or audio clips, digital
        downloads, data compilations and software, is the property of LIFE365 or
        its affiliates or vendors and is protected under applicable United
        States and international patent, copyright, trademark and other
        intellectual property laws. The compilation of all content on this
        Website, as well as the original arrangement, organization, design,
        formatting, trade dress, look and feel of the Website is also the
        exclusive property of LIFE365 or its respective affiliates or vendors
        and is also protected by United States and international intellectual
        property laws.
      </p>
      <p>Copyright © 2020 Life365, Inc. All rights reserved.</p>
      <p>
        LIFE365 or its affiliates are the owner of the trademarks CAREABLE™,
        PERSONALYZE™, INDELIVING™, LIFE IN CONTEXT™, LIFEOS™, I AM ME™, I
        AM HUMAN™, INSIGHT365™, MYLIFE365(R), L365(R), LIFECONNECT(R),
        CLOUDCARE(R) and LIFE365(R), among others. Other graphics, logos, button
        icons, and service names appearing on this Website are also the
        distinctive and protected trademarks, service marks, or trade names of
        LIFE365 or its affiliates. This Website may contain various third-party
        names and marks that are the property of their respective owners.
      </p>
      <p>
        Any unauthorized use of our marks or of our copyrighted material or
        trade dress or any other intellectual property is strictly prohibited
        and may be prosecuted to the fullest extent that the law provides.
      </p>
      <h2>Submissions</h2>
      <p>
        Should you send LIFE365 any Website postings, feedback or data, such as
        ideas, comments, and suggestions or questions regarding any LIFE365
        product or service (including this Website or Portal), such information
        will not be given confidential treatment. LIFE365 will not have any
        obligation of any kind to you with respect to any postings, feedback or
        data that you submit regarding the Website. Your submission of such
        postings, feedback and data affects an assignment to LIFE365 of such
        material (along with any underlying or related ideas, concepts,
        techniques and know-how) and you agree to assign and hereby assign all
        such postings, feedback and data to LIFE365 without charge. As the sole
        and exclusive owner of such postings, feedback and data, LIFE365 will be
        free to reproduce, copy, use, disclose and distribute the information to
        others including without limitation incorporating your postings,
        feedback or data (and any underlying or related ideas, concepts,
        techniques and know-how) into any LIFE365 product or service or this
        Website without compensation to you of any kind.
      </p>
      <p>
        Notwithstanding the above, certain portions of the Portal may permit and
        facilitate communications via the Portal between patients and
        caregivers, which will be kept confidential as required by law.
      </p>
      <h2>License to Access</h2>
      <p>
        You may view, copy, print and use content contained on this Website
        solely for your own personal use, provided that: (1) it is used for your
        internal or personal purposes only; (2) no text, graphics or other
        content available from this Website is modified or framed in any way;
        and (3) no graphics available from this Website are used, copied or
        distributed separate from accompanying text. The use of any content for
        commercial purposes is expressly prohibited. Nothing in this Agreement
        is intended to, or may be construed as, conferring by implication,
        estoppel or otherwise any license or other grant of right to use any
        patent, copyright, trademark, service mark or other intellectual
        property of LIFE365 or any third party, except as expressly provided in
        this section.
      </p>
      <p>
        You may not use, copy, modify, distribute, translate, reproduce,
        republish, disassemble, reverse engineer, decompile, mirror, frame,
        hyperlink or transmit any of the content or materials of this Website or
        rent or sell use of or access to (such as on a time share or service
        bureau basis) this Website, or any of the content or materials on this
        Website. You may not permit third parties to access this Website or use
        any Website content and may not make any other use of the Website or any
        Website content except as set forth in this Agreement, unless otherwise
        expressly agreed to in writing by LIFE365. You may not harvest or
        collect information about others, including e-mail addresses.
      </p>
      <p>
        You agree to use the Website for lawful purposes only. You may not post
        or transmit through the Website any material (i) that violates or
        infringes in any way upon the rights of others, (ii) that is unlawful,
        threatening, abusive, defamatory, invasive of privacy or publicity
        rights, vulgar, obscene, profane or otherwise objectionable, (iii) that
        encourages conduct that would constitute a criminal offense, give rise
        to civil liability or otherwise violate any law, or (iv) that, without
        LIFE365 express prior approval, contains advertising or any
        solicitation. Any conduct by you that, in our discretion, restricts or
        inhibits any other person from using or enjoying the Website will not be
        permitted.
      </p>
      <p>
        You understand and agree that LIFE365 may terminate or otherwise deny
        your access to the Website and without notice in the event LIFE365
        believes in its sole discretion that (i) you have violated a provision
        of this Agreement or your Registration Agreement, (ii) you have used or
        misused the Website in a manner that LIFE365 has determined is unlawful,
        unethical or otherwise inappropriate, or (iii) such action is reasonably
        necessary to protect a third party or LIFE365 or if such action is
        otherwise required by law.
      </p>
      <p>
        You acknowledge and agree (1) that your use of this Website is at your
        own discretion and risk, (2) that use of any material, information or
        data downloaded or otherwise obtained through the use of this Website is
        at your own discretion and risk, and (3) that you are solely responsible
        for any damage to your computer system for loss of data that results
        from the download of such material, information or data, and for any
        other form of damage that may be incurred.
      </p>
      <h2>Third-Party Websites</h2>
      <p>
        This Website may contain links to, or be accessed through links on,
        websites managed and operated by or on behalf of third parties
        (including your physician) or other third party entities. These third
        parties are separate and independent entities and are not agents of
        LIFE365. LIFE365 does not have control over such third party websites or
        the content of such websites. As a result, LIFE365 does not have
        responsibility for the information, misinformation, errors,
        availability, operation or performance of any such third party website
        to which this Website may link or from which this Website may be
        accessed.
      </p>
      <h2>Linking</h2>
      <p>
        If you operate another website and are interested in linking to our
        Website, you agree to be bound by the following rules: (1) the link must
        be a text-only link clearly marked; (2) the link must “point” to the URL
        for the home page for this Website and not to any other pages; (3) the
        link, and use thereof, must be in connection with a website of
        appropriate subject matter; (4) the link, and use thereof, may not be
        such that may damage or dilute the goodwill associated with LIFE365’s or
        its affiliates name, trademarks or services; (5) the link, and use
        thereof, may not create the false appearance that another entity is
        associated with or sponsored by LIFE365 or its affiliates; and (6) the
        link, when activated by a user, must display this Website full-screen
        and not with a “frame” on the linked website. LIFE365 reserves the right
        to revoke consent to the link at any time in its sole discretion; either
        by amending this Agreement or through other notice to you or to approved
        other forms of linking in writing.
      </p>
      <h2>No Endorsements</h2>
      <p>
        Reference to any pharmacy, physician, product, recording, event,
        process, publication, service, or offering of any third party by name,
        trade name, trademark, service mark, company name or otherwise does not
        constitute or imply the endorsement or recommendation of such by
        LIFE365. Any views expressed by third parties on this Website are solely
        the views of such third party and LIFE365 assumes no responsibility for
        the accuracy or veracity of any statement made by such third party.
      </p>
      <h2>Warranty Disclaimer</h2>
      <h3>
        THIS WEBSITE AND ALL INFORMATION, SERVICES AND RELATED MATERIALS IT
        CONTAINS ARE PROVIDED “AS IS,” “AS AVAILABLE” AND “WITH ALL FAULTS.”
        LIFE365 MAKES NO REPRESENTATION OR WARRANTY WHATSOEVER REGARDING THE
        COMPLETENESS, ACCURACY, CURRENCY, OR ADEQUACY OF, OR THE SUITABILITY,
        FUNCTIONALITY, AVAILABILITY, OR OPERATION OF THIS WEBSITE OR THE
        INFORMATION OR MATERIALS IT CONTAINS. TO THE FULLEST EXTENT PERMISSIBLE
        UNDER APPLICABLE LAW, LIFE365, AND ITS RESPECTIVE AFFILIATES AND
        VENDORS, SPECIFICALLY DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, WITH
        RESPECT TO THIS WEBSITE AND THE INFORMATION AND MATERIALS CONTAINED ON
        THIS WEBSITE, INCLUDING WITHOUT LIMITATION THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
        NON-INFRINGEMENT AND ANY WARRANTIES ARISING FROM A COURSE OF DEALING OR
        USAGE IN TRADE.
      </h3>
      <h3>
        USE OF THE INTERNET IS INHERENTLY UNRELIABLE. AS A RESULT, LIFE365 DOES
        NOT WARRANT THAT THE WEBSITE OR YOUR ACCESS TO THE WEBSITE WILL BE
        UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS IN THE WEBSITE WILL BE
        CORRECTED, OR THAT THIS WEBSITE OR THE SERVER THAT MAKES IT AVAILABLE
        ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. LIFE365 DOES NOT
        WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OR THE RESULTS OF
        THE USE OF THE MATERIALS IN THIS WEBSITE IN TERMS OF THEIR CORRECTNESS,
        ACCURACY, RELIABILITY, OR OTHERWISE.
      </h3>
      <h3>
        YOU UNDERSTAND THAT USE OF THE INTERNET AND THIS WEBSITE IS AT YOUR OWN
        RISK. NEITHER LIFE365 NOR ITS RESPECTIVE VENDORS, AFFILIATES OR
        SUPPLIERS IS RESPONSIBLE FOR ANY VIRUS OR DAMAGE TO YOUR COMPUTER,
        COMPUTER SOFTWARE, OR ANY LOSS OF DATA THAT MAY RESULT FROM USE OF THE
        WEBSITE OR ACCESS TO ANY CONTENT OR SERVICES.
      </h3>
      <p>
        This Website may be unavailable from time to time due to mechanical,
        telecommunication, software, and third-party vendor failures. LIFE365
        cannot predict or control when such downtime may occur and cannot
        control the duration of such downtime. As a result, LIFE365 cannot and
        does not have any liability for such failures.
      </p>
      <p>
        Reasonable efforts are taken to ensure the accuracy and integrity of
        information and related materials provided by LIFE365 on this Website,
        but LIFE365 is not responsible for misprints, out-of-date information,
        technical or pricing inaccuracies, typographical or other errors.
        Information and related materials are subject to change without notice.
      </p>
      <p>
        No advice or information from LIFE365 in any manner will create any
        warranty as to this Website or any product, service or material
        available through this Website. If for any reason you are not satisfied
        with this Website or its content, your sole remedy is to cease using
        this Website or such content, even if such remedy should fail of its
        essential purpose.
      </p>
      <p>
        Applicable law may not allow the exclusion of implied warranties, so the
        above exclusion may not apply to you.
      </p>
      <h2>Limitation of Liability</h2>
      <h3>
        TO THE EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL LIFE365 OR
        ANY OF ITS RESPECTIVE VENDORS, AFFILIATES, OFFICERS, MEMBERS,
        REPRESENTATIVES, SUPPLIERS, DIRECTORS, EMPLOYEES, CONSULTANTS, OWNERS,
        OR AGENTS BE LIABLE FOR DAMAGES OF ANY KIND, INCLUDING WITHOUT
        LIMITATION ANY DAMAGES FOR LOSS OF USE, DATA, INFORMATION, PROFITS,
        BUSINESS, REVENUE, EXPECTED SAVINGS OR BUSINESS INTERRUPTION, OR ANY
        DIRECT, SPECIAL, INDIRECT, INCIDENTAL, EXEMPLARY, PUNITIVE OR
        CONSEQUENTIAL DAMAGES ARISING FROM OR OTHERWISE RELATED TO THIS WEBSITE
        OR YOUR USE OF THIS WEBSITE, WHETHER SUCH DAMAGES ARE BASED IN TORT,
        CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF LIFE365 HAS
        BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR SUCH DAMAGES WERE
        OTHERWISE FORESEEABLE. YOUR SOLE AND EXCLUSIVE REMEDY IN THE EVENT OF
        SUCH DAMAGE IS TO DISCONTINUE YOUR ACCESS TO AND USE OF THIS WEBSITE.
        NOTWITHSTANDING THE FOREGOING, IN ANY EVENT, TO THE EXTENT PERMITTED BY
        APPLICABLE LAW THE AGGREGATE LIABILITY OF LIFE365 AND ITS AFFILIATES AND
        VENDORS FOR ANY REASON SHALL NOT EXCEED $100.00 US DOLLARS, EVEN IF SUCH
        REMEDY SHOULD FAIL OF ITS ESSENTIAL PURPOSE.
      </h3>
      <h2>Indemnification</h2>
      <h3>
        YOU AGREE TO DEFEND, INDEMNIFY AND HOLD HARMLESS LIFE365 AND ITS
        RESPECTIVE VENDORS, AFFILIATES AND THEIR OFFICERS, DIRECTORS,
        REPRESENTATIVES, EMPLOYEES, CONSULTANTS, AND AGENTS FROM AND AGAINST ANY
        CLAIMS, ALLEGATIONS, DAMAGES, LOSSES, LIABILITIES OR EXPENSES
        (INCLUDING, BUT NOT LIMITED TO ATTORNEYS’ FEES) THAT SUCH PARTY MAY
        SUFFER OR INCUR AS A RESULT OF (I) YOUR USE OR MISUSE OF THE WEBSITE,
        (II) YOUR INFRINGEMENT OF ANY INTELLECTUAL PROPERTY OR OTHER RIGHT OF
        LIFE365, OR ANY OTHER PERSON OR ENTITY, (III) YOUR VIOLATION OF ANY
        APPLICABLE LAW, INCLUDING WITHOUT LIMITATION ANY PRIVACY OR DATA
        SECURITY LAW OR REGULATION. OR (IV) YOUR VIOLATION OF THIS AGREEMENT.
        NOTWITHSTANDING THE FOREGOING, LIFE365 RESERVES THE RIGHT TO PARTICIPATE
        IN THE DEFENSE OF ANY SUCH CLAIM, SUBJECT TO YOUR INDEMNIFICATION
        OBLIGATION.
      </h3>
      <h2>Disputes and Interpretation</h2>
      <p>
        This Agreement is governed by and interpreted under the laws of the
        State of Arizona and the federal laws of the United States, without
        regard to conflicts of laws principles. This Agreement and access to the
        Website will be deemed to have been performed and occurred in the State
        of Arizona and the courts of that State will have exclusive jurisdiction
        to entertain any action arising under this Agreement. You hereby
        irrevocably submit to the exclusive jurisdiction and venue of the stated
        and federal courts with jurisdiction over the County of Maricopa,
        Arizona, as applicable, and waive any objections as to personal
        jurisdiction, venue and forum nonconveniens.
      </p>
      <p>
        In the event of any dispute, the prevailing party shall be entitled to
        recovery of its reasonable attorneys’ fees and costs. Except as
        otherwise prohibited by applicable law, any cause of action or claim
        with respect to this Website must be commenced within one (1) year after
        the action or claim arises. Certain provisions, by their nature or as
        explicitly stated, will survive any termination or expiration of this
        Agreement. If any of these conditions shall be deemed invalid, void, or
        for any reason unenforceable, that condition will be severable and shall
        not affect the validity and enforceability of any remaining condition.
      </p>
      <p>
        This Agreement, along with our Privacy Policy and where applicable the
        Registration Agreement or the Practice Agreement, , are the sole terms
        governing your use and access of this Website and supersedes all other
        agreements regarding use of the Website. Any waiver of any portion of
        this Agreement will be effective only if in writing and signed by
        LIFE365.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions about the Terms & Conditions of Use, please
        contact us at:
      </p>
      <p>
        Life365, Inc.
        <br />
        10105 E Via Linda, Suite 103-285
        <br />
        Scottsdale, AZ 85258
        <br />
        Tel: (888) 818-2322
        <br />
        Email: support@life365.health
        <br />
      </p>
    </StyledDiv>
  );
}
